import {Component, NgZone, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseurlService} from '../../services/baseurl.service';

@Component({
    selector: 'app-sse-test',
    templateUrl: './sse-test.component.html',
    styleUrls: ['./sse-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SseTestComponent implements OnInit, OnDestroy {

  times: string[] = [];
  sse: EventSource;

  constructor(
    private zone: NgZone,
    private baseUrlServic: BaseurlService,
  ) {
  }

  ngOnInit(): void {

    this.sse = new EventSource(this.baseUrlServic.getBaseUrl() + '/sse');
    this.sse.onmessage = (evt) => {
      console.info('received data', evt);

      this.zone.run(() => {
        this.times.push(evt.data);
      });
    };
  }

  ngOnDestroy() {
    this.sse.close();
  }


  getTimes() {
    return this.times;
  }
}
